/**
 * MFA analytics action constants
 *
 * Tracks all user interactions with the MFA enrollment, challenge, and management flows.
 */
export const MFA_ACTIONS = {
  MFA_ENROLLMENT_STARTED: 'mfa_enrollment_started',
  MFA_ENROLLMENT_QR_DISPLAYED: 'mfa_enrollment_qr_displayed',
  MFA_ENROLLMENT_MANUAL_KEY_COPIED: 'mfa_enrollment_manual_key_copied',
  MFA_ENROLLMENT_VERIFICATION_ATTEMPT: 'mfa_enrollment_verification_attempt',
  MFA_ENROLLMENT_COMPLETED: 'mfa_enrollment_completed',
  MFA_ENROLLMENT_FAILED: 'mfa_enrollment_failed',
  MFA_ENROLLMENT_CANCELLED: 'mfa_enrollment_cancelled',
  MFA_BACKUP_CODES_GENERATED: 'mfa_backup_codes_generated',
  MFA_BACKUP_CODES_DOWNLOADED: 'mfa_backup_codes_downloaded',
  MFA_CHALLENGE_PRESENTED: 'mfa_challenge_presented',
  MFA_CHALLENGE_ATTEMPT: 'mfa_challenge_attempt',
  MFA_CHALLENGE_SUCCESS: 'mfa_challenge_success',
  MFA_CHALLENGE_FAILED: 'mfa_challenge_failed',
  MFA_CHALLENGE_RATE_LIMITED: 'mfa_challenge_rate_limited',
  MFA_UNENROLLMENT_STARTED: 'mfa_unenrollment_started',
  MFA_UNENROLLMENT_COMPLETED: 'mfa_unenrollment_completed',
  MFA_UNENROLLMENT_FAILED: 'mfa_unenrollment_failed',
  MFA_RECOVERY_CODE_USED: 'mfa_recovery_code_used',
  MFA_TRUSTED_DEVICE_OPTED_IN: 'mfa_trusted_device_opted_in',
  MFA_TRUSTED_DEVICE_BYPASS_ATTEMPTED: 'mfa_trusted_device_bypass_attempted',
  MFA_TRUSTED_DEVICE_BYPASS_SUCCESS: 'mfa_trusted_device_bypass_success',
  MFA_TRUSTED_DEVICE_BYPASS_FAILED: 'mfa_trusted_device_bypass_failed',
  MFA_TRUSTED_DEVICE_REVOKED: 'mfa_trusted_device_revoked',
  MFA_TRUSTED_DEVICES_REVOKED_ALL: 'mfa_trusted_devices_revoked_all',
} as const;
